import { ReactComponent as SearchOutlinedIcon } from "assets/icons/search-icon.svg";
import { varIs, varKey, varLabel } from "common/var";
import {
  Button,
  CountryFlag,
  Input,
  Modal,
  MonthPicker,
  Select,
  Table,
  TablePanel,
  UserAvatar,
} from "components/common";
import moment from "moment";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { callGetApiWithAuth } from "utils/api";
import { asCurrencyPrice, asDate, asVolume } from "utils/text";

export default function CustomerPodReportPage() {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 15,
    total: 0,
  });
  const [searchParam, setSearchParam] = useState({
    user_id: "",
    uuid: "",
    status: "",
    has_subscription: "",
    month: moment().startOf("month").format("YYYY-MM"),
    from: moment().startOf("month").format("YYYY-MM-DD"),
    to: moment().endOf("month").format("YYYY-MM-DD"),
  });

  const onChangeDate = (v) => {
    let searchParam0 = {
      ...searchParam,
      month: moment(v).startOf("month").format("YYYY-MM"),
      from: moment().startOf("month").format("YYYY-MM-DD"),
      to: moment().endOf("month").format("YYYY-MM-DD"),
    };
    if (v) {
      searchParam0 = {
        ...searchParam,
        month: moment(v).startOf("month").format("YYYY-MM"),
        from: moment(v).startOf("month").format("YYYY-MM-DD"),
        to: moment(v).endOf("month").format("YYYY-MM-DD"),
      };
    }
    setSearchParam(searchParam0);
    loadTableData(paginationParam, searchParam0);
  };

  const loadTableData = (paginationParam0, searchParam0) => {
    setIsLoading(true);
    const params = {
      ...searchParam0,
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    callGetApiWithAuth(
      `report/customer_report/pod_list?${q}`,
      ({ data }) => {
        setTableData(data.data);
        setPaginationParam({
          ...paginationParam,
          currentPage: data.current_page,
          total: data.total,
        });
        setIsLoading(false);
      },
      () => {
        setIsLoading(false);
      }
    );
  };

  const handleSearch = () => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: 1,
    };
    loadTableData(paginationParam0, searchParam);
  };

  const onPageChange = (page) => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: page,
    };
    loadTableData(paginationParam0, searchParam);
  };

  const onFormInput = (field, value) => {
    setSearchParam({
      ...searchParam,
      [field]: value,
    });
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const onExportDone = (res) => {
    setIsExporting(false);
    window.open(res.data.csv_file, "_blank");
  };
  const onExportFail = () => {
    setIsExporting(false);
  };

  const handleExport = () => {
    setIsExporting(true);
    const params = {
      ...searchParam,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    callGetApiWithAuth(
      `report/customer_report/export_pod_list?${q}`,
      onExportDone,
      onExportFail
    );
  };

  return (
    <Wrapper>
      <TablePanel
        data={tableData}
        loading={isLoading}
        paginationParam={paginationParam}
        onPageChange={onPageChange}
        columns={[
          {
            title: "User ID",
            key: "uuid",
            render: (_, record) => <span>#{record.uuid}</span>,
          },
          {
            title: "Username",
            key: "username",
            render: (_, record) => <span>{record.username}</span>,
          },

          {
            title: "Name",
            key: "name",
            render: (_, record) => (
              <UserAvatar
                image={record.image}
                title={`${record.first_name} ${record.last_name}`}
                status={varKey("user.status", record.status)}
                type={varKey("user.type", record.type)}
                typeLabel={varLabel("user.type", record.type)}
                joinDate={asDate(record.created_at)}
              />
            ),
          },
          {
            title: "Email",
            render: (_, record) => <span>{`${record.email}`}</span>,
          },
          {
            title: "Country",
            key: "country",
            render: (_, record) => <CountryFlag country={record.country} />,
          },
          // {
          //   title: "Pod Owner ID",
          //   key: "pod_owner_uuid",
          //   render: (_, record) => <span>#{record.pod_owner && record.pod_owner.uuid}</span>,
          // },
          // {
          //   title: "Pod Owner",
          //   key: "pod_owner",
          //   render: (_, record) => (
          //     record.pod_owner && <UserAvatar
          //       image={record.pod_owner.image}
          //       title={`${record.pod_owner.first_name} ${record.pod_owner.last_name}`}
          //     />
          //   ),
          // },
          {
            title: "CP",
            key: "cp",
            render: (_, record) => <span>{asVolume(record.cp)}</span>,
          },
          {
            title: "CV",
            key: "cv",
            render: (_, record) => <span>{asVolume(record.cv)}</span>,
          },
          {
            title: "Subscription",
            key: "subscription",
            render: (_, record) =>
              record.subscription_count * 1 > 0 ? (
                <span className="subscription-yes">Yes</span>
              ) : (
                <span className="subscription-no">No</span>
              ),
          },
          {
            title: "Order History",
            render: (_, record) => <OrderListTd data={record} />,
          },
        ]}
        toolbar={
          <div className="searchActionContainer">
            <div className="searchField search_bar">
              <Input
                value={searchParam.uuid}
                onChange={(e) => onFormInput("uuid", e.target.value)}
                label={"By User ID, Name, Email"}
                inputPrefix={<SearchOutlinedIcon />}
              />
            </div>
            <div className="searchField">
              <Select
                value={searchParam.status}
                label="Select Status"
                onChange={(v) => onFormInput("status", v)}
                options={[
                  { label: "Any", value: "" },
                  { label: "Active", value: "active" },
                  { label: "Inactive", value: "inactive" },
                  { label: "Closed", value: "closed" },
                  { label: "Purged", value: "purged" },
                ]}
                style={{ minWidth: "150px" }}
              />
            </div>

            <div className="searchField">
              <Select
                value={searchParam.has_subscription}
                label="Has Subscription"
                onChange={(v) => onFormInput("has_subscription", v)}
                options={[
                  { label: "Any", value: "" },
                  { label: "Yes", value: 1 },
                  { label: "No", value: 2 },
                ]}
                style={{ minWidth: "150px" }}
              />
            </div>
            <div className="searchField">
              <MonthPicker
                date={searchParam.from}
                onChange={(v) => onChangeDate(v)}
              />
            </div>
            <div className="actionButton">
              <Button onClick={handleSearch} className="button-colors">
                Search
              </Button>
              {/* <Button
                onClick={handleExport}
                loading={isExporting}
                className="button-colors"
              >
                Export
              </Button> */}
            </div>
          </div>
        }
      />
    </Wrapper>
  );
}

const OrderListTd = ({ data }) => {
  const [modalMode, setModalMode] = useState(undefined);

  return (
    <>
      {data.last_orders.length > 0 && (
        <a href="#" onClick={() => setModalMode("orders")}>
          View Details
        </a>
      )}
      {modalMode === "orders" && (
        <Modal
          title={"Order History"}
          width={1024}
          onCancel={() => setModalMode(undefined)}
        >
          <ModalWrap>
            <Table
              pagination={false}
              dataSource={data.last_orders}
              columns={[
                {
                  title: "Order Number",
                  render: (_, record) => <span>{record.order_number}</span>,
                },
                {
                  title: "Date",
                  render: (_, record) => (
                    <span>
                      {record.qualified_at ? asDate(record.qualified_at) : "-"}
                    </span>
                  ),
                },
                {
                  title: "Total Amount",
                  render: (_, record) => (
                    <span>
                      {varIs(
                        "userBillingDetail.payType",
                        record.pay_type,
                        "coin"
                      )
                        ? `${record.merchant_amount || ""} ${record.coin_type
                          ? record.coin_type.toUpperCase()
                          : ""
                        }`
                        : asCurrencyPrice(
                          record.local_order_total_amount,
                          record.currency_code
                        )}
                    </span>
                  ),
                },
                {
                  title: "Total Volume",
                  render: (_, record) => (
                    <span>{asVolume(record.order_total_pv)}</span>
                  ),
                },
                {
                  title: "Products",
                  render: (_, record) => (
                    <div>
                      {record.details.map((el) => (
                        <div>{`${el.quantity} x ${el.title}`}</div>
                      ))}
                    </div>
                  ),
                },
                {
                  title: "Tracking Number",
                  render: (_, record) => <a href={record.tracking_url} target="_blank" rel="noreferrer">{record.tracking_number}</a>,
                }
              ]}
            />
          </ModalWrap>
        </Modal>
      )}
    </>
  );
};

const Wrapper = styled.div`
  .button-colors {
    background-color: #0abab5;
    color: #fff;
  }

  .panelHead {
    flex-wrap: wrap;
    .ant-radio-group {
      margin-top: 2px;
      margin-bottom: 2px;
    }
    .searchActionContainer {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;
    }
  }
  .searchField {
    display: flex;
    align-items: center;
    .input-prefix {
      svg {
        width: 15px;
        height: 15px;
        margin-bottom: 5px;
      }
    }
    .ant-input {
      height: 40px !important;
    }
    .ant-select-selector {
      height: 40px !important;
      padding-top: 4px !important;
    }
    .ant-select {
      height: 40px !important;
      color: #212b36;
    }
  }
  .name-icons {
    path {
      color: #0abab5;
    }
  }

  .actionButton {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .search_bar {
    .ant-form-item-label {
      top: 9px !important;
      left: 44px !important;
    }
    .ant-form-item-label-active {
      transform: translateY(-17px) scale(1) !important;
    }
  }

  @media (max-width: 1494px) {
    .panelHead {
      flex-direction: column !important;
      align-items: start !important;
      gap: 24px !important;
      .ant-select-selector {
        width: auto !important;
      }
      .searchField {
        width: auto !important;
      }
    }
  }
  @media (max-width: 1100px) {
    .panelHead {
      h4 {
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
    .toolbar {
      .searchActionContainer {
        gap: 24px !important;
        .searchField,
        .actionButton {
          width: 100% !important;
        }
        .actionButton {
          button {
            width: 50%;
          }
        }
        .sc-ksdxgE,
        .sc-iqseJM {
          width: 100% !important;
        }
      }
    }

    .ant-select-selector {
      width: 100% !important;
    }
  }
`;

const ModalWrap = styled.div`
  margin: -24px -24px 0 -24px;
  .ant-table-wrapper {
    overflow-x: auto;
  }
  .ant-table-container {
    min-width: 900px;
  }
`;
